import {range} from "utils/DBUtils";
import React from 'react';
import {
    AgeGatingCodesToolTip,
    ApplyAgeTargetingToolTip,
    AgeTargetingCodesToolTip,
    ApplyAgeGatingToolTip,
    BlockedZipCodesToolTip,
    GenderedTargetsToolTip,
    SegmentsToolTip,
    StateFiltersToolTip,
    TargetZipCodesToolTip
} from "components/break/tooltips/break-campaign-targeting-tool-tips";
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    key: "breaksCampaignTargeting",
    showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored'),
    props: {
        headerKey: 'editbreak.section.targeting.heading'
    },
    fields: [
        {
            type: 'hardcodedText',
            props: {
              text: 'Targeting determines whether consumers will see a tile for this break on the homepage.',
            }
        },
        {
            type: 'checkbox',
            name: 'segments',
            props: {
                labelKey: 'editbreak.targeting.segments',
                options: range(12).map((item) => ({
                    value: item+1,
                    text: item+1
                })),
                helpContent: <SegmentsToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.segments'}/></IntlProvider>
            }
        },
        {
            type: 'checkbox',
            name: 'genders',
            props: {
                labelKey: 'editbreak.targeting.genders',
                options: [
                    {
                        value: 'male',
                        key: 'male',
                        textKey: 'editbreak.targeting.genders.male'
                    },
                    {
                        value: 'female',
                        key: 'female',
                        textKey: 'editbreak.targeting.genders.female'
                    },
                    {
                        value: 'unspecified',
                        key: 'unspecified',
                        textKey: 'editbreak.targeting.genders.unspecified'
                    }
                ],
                helpContent: <GenderedTargetsToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.genders'}/></IntlProvider>
            }
        },
        {
            type: 'checkbox',
            name: 'retailers',
            props: {
                labelKey: 'Retailers',
                options: [
                    {
                        value: '1',
                        text: 'Walmart'
                    },
                    {
                        value: '2',
                        text: 'Kroger'
                    },
                    {
                        value: '3',
                        text: 'CVS'
                    },
                    {
                        value: '4',
                        text: 'Dollar Store'
                    },
                    {
                        value: '5',
                        text: 'Target'
                    },
                    {
                        value: '6',
                        text: 'Albertons'
                    },
                    {
                        value: '7',
                        text: 'Walgreens'
                    },
                    {
                        value: '8',
                        text: 'Safeway'
                    },
                    {
                        value: '9',
                        text: 'Amazon'
                    },
                    {
                        value: '10',
                        text: 'Publix'
                    },
                    {
                        value: '11',
                        text: 'Club Store'
                    },
                    {
                        value: '12',
                        text: 'Other'
                    }
                ],
            }
        },
        {
            type: 'checkbox',
            name: 'states',
            props: {
                labelKey: 'editbreak.targeting.states',
                options: [
                    {
                        value: "AK",
                        text: "AK"
                    },
                    {
                        value: "AL",
                        text: "AL"
                    },
                    {
                        value: "AR",
                        text: "AR"
                    },
                    {
                        value: "AZ",
                        text: "AZ"
                    },
                    {
                        value: "CA",
                        text: "CA"
                    },
                    {
                        value: "CO",
                        text: "CO"
                    },
                    {
                        value: "CT",
                        text: "CT"
                    },
                    {
                        value: "DE",
                        text: "DE"
                    },
                    {
                        value: "FL",
                        text: "FL"
                    },
                    {
                        value: "GA",
                        text: "GA"
                    },
                    {
                        value: "HI",
                        text: "HI"
                    },
                    {
                        value: "IA",
                        text: "IA"
                    },
                    {
                        value: "ID",
                        text: "ID"
                    },
                    {
                        value: "IL",
                        text: "IL"
                    },
                    {
                        value: "IN",
                        text: "IN"
                    },
                    {
                        value: "KS",
                        text: "KS"
                    },
                    {
                        value: "KY",
                        text: "KY"
                    },
                    {
                        value: "LA",
                        text: "LA"
                    },
                    {
                        value: "MA",
                        text: "MA"
                    },
                    {
                        value: "MD",
                        text: "MD"
                    },
                    {
                        value: "ME",
                        text: "ME"
                    },
                    {
                        value: "MI",
                        text: "MI"
                    },
                    {
                        value: "MN",
                        text: "MN"
                    },
                    {
                        value: "MO",
                        text: "MO"
                    },
                    {
                        value: "MS",
                        text: "MS"
                    },
                    {
                        value: "MT",
                        text: "MT"
                    },
                    {
                        value: "NC",
                        text: "NC"
                    },
                    {
                        value: "ND",
                        text: "ND"
                    },
                    {
                        value: "NE",
                        text: "NE"
                    },
                    {
                        value: "NH",
                        text: "NH"
                    },
                    {
                        value: "NJ",
                        text: "NJ"
                    },
                    {
                        value: "NM",
                        text: "NM"
                    },
                    {
                        value: "NV",
                        text: "NV"
                    },
                    {
                        value: "NY",
                        text: "NY"
                    },
                    {
                        value: "OH",
                        text: "OH"
                    },
                    {
                        value: "OK",
                        text: "OK"
                    },
                    {
                        value: "OR",
                        text: "OR"
                    },
                    {
                        value: "PA",
                        text: "PA"
                    },
                    {
                        value: "RI",
                        text: "RI"
                    },
                    {
                        value: "SC",
                        text: "SC"
                    },
                    {
                        value: "SD",
                        text: "SD"
                    },
                    {
                        value: "TN",
                        text: "TN"
                    },
                    {
                        value: "TX",
                        text: "TX"
                    },
                    {
                        value: "UT",
                        text: "UT"
                    },
                    {
                        value: "VA",
                        text: "VA"
                    },
                    {
                        value: "VT",
                        text: "VT"
                    },
                    {
                        value: "WA",
                        text: "WA"
                    },
                    {
                        value: "WI",
                        text: "WI"
                    },
                    {
                        value: "WV",
                        text: "WV"
                    },
                    {
                        value: "WY",
                        text: "WY"
                    }
                ],
                helpContent: <StateFiltersToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.states'}/></IntlProvider>
            }
        },
        {
            type: 'textarea',
            name: 'zips',

            props: {
                labelKey: 'editbreak.targeting.targetZipCodes',
                helpContent: <TargetZipCodesToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.targetZipCodes'}/></IntlProvider>,
                asList: true
            }
        },
        {
            type: 'textarea',
            name: 'excludedZips',

            props: {
                labelKey: 'editbreak.targeting.excludedZipCodes',
                helpContent: <BlockedZipCodesToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.excludedZipCodes'}/></IntlProvider>,
                asList: true
            }
        },
        {
            conditionalSection: true,
            name: "hasAgeTargeting",
            required: true,
            props: {
                labelKey: 'editbreak.targeting.has_age_targeting',
                helpContent: <ApplyAgeTargetingToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.has_age_targeting'}/></IntlProvider>
            },

            fields: [
              {
                  type: 'number',
                  name: 'ageTargets.min',

                  props: {
                      labelKey: 'editbreak.targeting.age_target_min',
                      helpContent: <AgeTargetingCodesToolTip/>,
                      helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.age_target_min'}/></IntlProvider>
                  }
              },
              {
                  type: 'number',
                  name: 'ageTargets.max',

                  props: {
                      labelKey: 'editbreak.targeting.age_target_max',
                      helpContent: <AgeTargetingCodesToolTip/>,
                      helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.targeting.age_target_max'}/></IntlProvider>
                  }
              },          
            ]
        },
 
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksCampaignTargeting.js